import { CALL_API } from "redux-api-middleware";
import quicklListApi from "apis/quickList";
import {
  REQUEST_QUICKLISTS, RECEIVE_QUICKLISTS, ERROR_QUICKLISTS,
  REQUEST_QUICKLISTTEMPLATES, RECEIVE_QUICKLISTTEMPLATES, ERROR_QUICKLISTTEMPLATES,
  REQUEST_QUICKLISTCOUNT, RECEIVE_QUICKLISTCOUNT, ERROR_QUICKLISTCOUNT,
  REQUEST_QUICKLISTRESULT, RECEIVE_QUICKLISTRESULT, ERROR_QUICKLISTRESULT,
  REQUEST_QUICKLISTSAVE, RECEIVE_QUICKLISTSAVE, ERROR_QUICKLISTSAVE,
  REQUEST_QUICKLISTGROUP, RECEIVE_QUICKLISTGROUP, ERROR_QUICKLISTGROUP,
  REQUEST_QUICKLISTDELETE, RECEIVE_QUICKLISTDELETE, ERROR_QUICKLISTDELETE,
  SET_CURRENT_QUICKLIST_ID, SET_CURRENT_QUICKLIST_ROW_INDEX,
} from "typeConstants";
import responseHandler from "responseHandler";
import { WebApiReduxRequest } from "tools/webservice";

const getQuickLists = (refreshList) => {
  return function (dispatch, getState) {

    // check if we already have the Quick lists.
    let { quickLists, quickListsLoaded } = getState().quickList;
    if (!refreshList && quickListsLoaded) {
      return dispatch({ type: RECEIVE_QUICKLISTS, payload: quickLists });
    }

    dispatch({
      [CALL_API]: {
        endpoint: quicklListApi.getQuickLists(),
        method: "GET",
        types: [
          REQUEST_QUICKLISTS,
          {
            type: RECEIVE_QUICKLISTS,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          }, {
            type: ERROR_QUICKLISTS,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    }
    );
  };
};

const getQuickListTemplates = callback => {
  return function (dispatch, getState) {

    // check if we already have the Quick list Templates.
    let { quickListTemplates } = getState().quickList;
    if (Object.keys(quickListTemplates).length !== 0) {
      return dispatch({ type: RECEIVE_QUICKLISTTEMPLATES, payload: { quickListTemplates: quickListTemplates } });
    }

    dispatch({
      [CALL_API]: {
        endpoint: quicklListApi.getQuickListSelectList(),
        method: "GET",
        types: [
          REQUEST_QUICKLISTTEMPLATES,
          {
            type: RECEIVE_QUICKLISTTEMPLATES,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  if (callback) callback(data);
                  return data;
                })
          }, {
            type: ERROR_QUICKLISTTEMPLATES,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    }
    );
  };
};

const getQuickListCount = (quickList, quickFilters) => WebApiReduxRequest(REQUEST_QUICKLISTCOUNT, RECEIVE_QUICKLISTCOUNT, ERROR_QUICKLISTCOUNT, "POST", quicklListApi.getQuickListCount(quickList.id), quickFilters);

const getQuickListResult = (quickList, quickFilters) => WebApiReduxRequest(REQUEST_QUICKLISTRESULT, RECEIVE_QUICKLISTRESULT, ERROR_QUICKLISTRESULT, "POST", quicklListApi.getQuickListResult(quickList.id), quickFilters);

const saveQuickList = (quickList) => {
  return function (dispatch) {
    dispatch({
      [CALL_API]: {
        endpoint: quicklListApi.saveQuickList(quickList.id),
        method: "POST",
        body: JSON.stringify(quickList),
        types: [
          {
            type: REQUEST_QUICKLISTSAVE,
            payload: quickList.id
          },
          {
            type: RECEIVE_QUICKLISTSAVE,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  setTimeout(() => {
                    let message = "Quick List Saved.";
                    responseHandler.success(message, dispatch);
                  }, 0);
                  return data;
                })
          }, {
            type: ERROR_QUICKLISTSAVE,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
              return { id: quickList.id };
            }
          }
        ]
      }
    }
    );
  };
};

const saveQuickListGroup = (items) => {
  let vm = global.structuredClone(items);
  return function (dispatch) {
    dispatch({
      [CALL_API]: {
        endpoint: quicklListApi.saveQuickListGroup(),
        method: "POST",
        body: JSON.stringify(vm),
        types: [
          REQUEST_QUICKLISTGROUP,
          {
            type: RECEIVE_QUICKLISTGROUP,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  setTimeout(() => {
                    let message = "Quick List Groups Updated.";
                    responseHandler.success(message, dispatch);
                  }, 0);

                  return data;
                })
          }, {
            type: ERROR_QUICKLISTGROUP,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    }
    );
  };
};


const deleteQuickList = (quickList) => {
  return function (dispatch) {
    dispatch({
      [CALL_API]: {
        endpoint: quicklListApi.deleteQuickList(quickList.id),
        method: "POST",
        body: JSON.stringify(quickList),
        types: [
          {
            type: REQUEST_QUICKLISTDELETE,
            payload: quickList.id
          },
          {
            type: RECEIVE_QUICKLISTDELETE,
            payload: (action, state, res) =>
              res.json()
                .then(() => {
                  // this will remove the deleted item from the store.
                  setTimeout(() => {
                    let message = "Quick List Deleted.";
                    responseHandler.success(message, dispatch);
                  }, 0);
                  return { deletedId: quickList.id };
                })
          }, {
            type: ERROR_QUICKLISTDELETE,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
              return { id: quickList.id };
            }
          }
        ]
      }
    }
    );
  };
};

// This action is only intended to update the data in redux. It will not update data in the backend.
const updateQuickListInPlace = (quickListUpdate) => {
  return function (dispatch, getState) {
    const { quickLists } = getState().quickList;
    const quickList = quickLists.find(ql => {
      return ql.id === quickListUpdate.id;
    });
    if (!quickList) {
      responseHandler.error(`Unable to find quicklist with id ${quickListUpdate.id}`, dispatch);
      return dispatch({ type: ERROR_QUICKLISTRESULT });
    }
    const data = [...quickList.result.data];
    quickListUpdate.update.forEach(update => {
      const index = data.findIndex(d => d[quickListUpdate.key] === update[quickListUpdate.key]);
      if (index > -1) {
        const row = { ...data[index], ...update };
        data.splice(index, 1, row);
      }
    });
    const result = {
      ...quickList.result,
      asOfDate: getDotNetDate(),
      data
    };
    return dispatch({ type: RECEIVE_QUICKLISTRESULT, payload: result });
  };
};

/*  updateQuickListInPlace should be called with this sort of object
{
  id, // Quicklist id to update, number
  key,  // Unique key to use to find what objects to update (eg: controlNumber), string
  update: [ // An array of objects that represent updates that should be made
    {
      keyName, // The key used above, use the key:value here (eg: controlNumber: 1234567890)
      keyToUpdate, // A property in the quick list results object to update (eg. underwriterCode: "TOREN"),
      otherKeyToUpdate, // Multiple properties can be updated
      etc
    }
  ]
}
*/

// Using this so the asOfDate matches as close as possible to what gets returned from the backend
const getDotNetDate = () => {
  const padNumber = (numberValue, length) => numberValue.toString().padStart(length, "0");

  const today = new Date();
  const year = today.getFullYear();
  const month = padNumber(today.getMonth() + 1, 2);
  const day = padNumber(today.getDate(), 2);
  const hour = padNumber(today.getHours(), 2);
  const min = padNumber(today.getMinutes(), 2);
  const sec = padNumber(today.getSeconds(), 2);
  const milli = padNumber(today.getMilliseconds(), 3).padEnd(7, "0");
  const offsetRaw = today.getTimezoneOffset() / 60;
  const offset = padNumber(Math.abs(offsetRaw), 2);
  const sign = offsetRaw > 0 ? "+" : "-";
  return `${year}-${month}-${day}T${hour}:${min}:${sec}.${milli}${sign}${offset}:00`;
};

const setCurrentQuicklistId = id => {
  return {
    type: SET_CURRENT_QUICKLIST_ID,
    payload: id,
  };
};

const setCurrentQuicklistRowIndex = index => {
  return {
    type: SET_CURRENT_QUICKLIST_ROW_INDEX,
    payload: index,
  };
};

export {
  deleteQuickList,
  getQuickLists,
  getQuickListTemplates,
  getQuickListCount,
  getQuickListResult,
  saveQuickList,
  saveQuickListGroup,
  updateQuickListInPlace,
  setCurrentQuicklistId,
  setCurrentQuicklistRowIndex,
};